import { render } from "./DetalharConvenio.vue?vue&type=template&id=0b62a5ac&scoped=true"
import script from "./DetalharConvenio.vue?vue&type=script&lang=js"
export * from "./DetalharConvenio.vue?vue&type=script&lang=js"

import "./DetalharConvenio.vue?vue&type=style&index=0&id=0b62a5ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b62a5ac"]])

export default __exports__